<template>
  <div>
    <location />
    <div class="page mt-0 login">
      <div class="mb-80 wrap-600 mw-400">
        <p class="lh-base mb-4">
        {{ $t("text.membership.drop_membership_1") }}
        </p>
        <p class="lh-base mb-4">
          {{ $t("text.membership.drop_membership_2") }}
        </p>
        <p class="icon-alarm">
          {{ $t("text.membership.drop_membership_3") }}
        </p>
      </div>
      <b-form @submit="onSubmit" class="d-flex flex-column wrap">
        <div class="d-flex gap-2">
          <button
            class="btn btn-outline-primary btn-lg w-100 mb-4"
            type="button"
            @click="$router.push({ name: 'MyProfile' })"
          >
          {{ $t("button.common.cancel") }}
          </button>
          <button
            class="btn btn-primary btn-lg w-100 mb-4"
            type="submit"
          >
          {{ $t('button.membership.cancel_membership') }}
          </button>
        </div>
        <p class="text-subscript text-center fs-14">
          <span class="material-icons-outlined me-1">info</span>
          <span>{{ $t("text.membership.security_password") }}</span>
        </p>
      </b-form>
    </div>
  </div>
</template>

<script>
import location from "@/components/Location";
import ax from "@/api/membership";

export default {
  name: "DeleteProfile",
  components: {
    location,
  },
  data() {
    return {
      password: "",
    };
  },
  methods: {
    onSubmit(event) {
      event.preventDefault();

      if (confirm(this.$i18n.t("text.common.unsubscribe"))) {
        ax.member_drop((flag, data) => {
          if (flag) {
            alert(data);
            this.$store.dispatch("logout");
            this.$router.push({ name: "main" });
          } else {
            alert(data);
          }
        });
      }

    },
  },
};
</script>
